import { C as Cart } from './cart-BCBag437.js';
import { P as Pubsub } from './pubsub-DKqIEqaC.js';
import './notyf-DIw0RvBj.js';

class FreeShippingBar extends HTMLElement {
  unsubscribers = [];

  static {
    Cart.sections.push('fetch-free-shipping-bar');
  }

  connectedCallback() {
    ['cart:add', 'cart:update', 'cart:change'].forEach((event) =>
      this.unsubscribers.push(
        Pubsub.subscribe(event, ({ sections }) => this.renderSection(sections))
      )
    );
  }

  disconnectedCallback() {
    this.unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  renderSection(sections) {
    const html = new DOMParser().parseFromString(sections['fetch-free-shipping-bar'], 'text/html');
    const target = html.querySelector('free-shipping-bar');

    this.innerHTML = target.innerHTML;
  }
}

customElements.define('free-shipping-bar', FreeShippingBar);
